export default __webpack_public_path__ + "static/media/family-in-park.eeb8e621.jpg";